class ToastComponent extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.timeoutId = null;
        this.duration = 3000;
    }

    connectedCallback() {
        this.render();
        this.setupStyles();
    }

    render() {
        this.shadowRoot.innerHTML = `
      <div class="toast" role="alert" aria-live="assertive">
        <div class="wrap-toast-content">
            <div class="toast-content">
                <span class="toast-message"></span>
            </div>
            <button class="toast-close" aria-label="Close notification">×</button>
        </div>
      </div>
    `;
        this.shadowRoot.querySelector('.toast-close').addEventListener('click', () => this.hide());
    }

    setupStyles() {
        const style = document.createElement('style');
        style.textContent = `
        .toast {
            position: fixed;
            top: 20px;
            left: 50%;
            transform: translate(-50%, 20px);
            padding: 12px 16px;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.2);
            z-index: 1000;
            max-width: 400px;
            width: max-content;
            opacity: 0;
            transition: all 0.3s ease;
            font-family: sans-serif;
            font-size: 14px;
            line-height: 1.4;
            white-space: pre-wrap;
            text-align: left;
            display: flex;
        }
        .toast.error { background: var(--brand-secondary-red, #830000); color: white; }
        .toast.warning { background: #FFA500; color: #000; }
        .toast.warning .toast-close { color: #000; }

        .toast.show { opacity: 1; transform: translate(-50%, 0); }
        .wrap-toast-content { display: flex; align-items: center; gap: 8px; }
        .toast-content { flex: 1; display: flex; }
        .toast-close { background: none; border: none; color: white; font-size: 18px; cursor: pointer; opacity: 0.8; }
        
        @media (max-width: 480px) {
            .toast { left: 10px; right: 10px; width: auto; transform: translateY(20px); }
            .toast.show { transform: translateY(0); }
        }
        `;
        this.shadowRoot.appendChild(style);
    }

    show(message, type = 'error', duration = this.duration) {
        const toast = this.shadowRoot.querySelector('.toast');
        this.shadowRoot.querySelector('.toast-message').textContent = message;

        toast.classList.remove('error', 'warning');
        toast.classList.add(type, 'show');

        if (this.timeoutId) clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => this.hide(), duration);
    }

    hide() {
        const toast = this.shadowRoot.querySelector('.toast');
        if (toast) toast.classList.remove('show');
        setTimeout(() => { if (this.parentNode) this.parentNode.removeChild(this); }, 300);
    }
}

if (!customElements.get('toast-component')) {
    customElements.define('toast-component', ToastComponent);
}

window.showToast = function (message, type = 'error', duration = 3000) {
    let toast = document.querySelector('toast-component');
    if (!toast) {
        toast = document.createElement('toast-component');
        document.body.appendChild(toast);
    }
    toast.show(message, type, duration);
};